import OutboundDealsApi from 'api/admins/outbound-deals-api'
import { TitlePage } from 'components/atoms'
import { ALERT_TYPES } from 'constants/alert-constants'
import OutboundDealsView from 'domains/outbound/deals/view/outbound-deals-view'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Button } from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const OutboundDealsDetailPage = ({ pageUtils }) => {
  const { id } = useParams()
  const [ deal, setDeal ] = useState({})
  const [ historyList, setHistoryList ] = useState([])
  const [ historyDetail, setHistoryDetail ] = useState({})
  const [ isLoading, setIsLoading ] = useState(true)

  const fetchDeal = () => {
    setIsLoading(true)

    OutboundDealsApi.show({ dealId: id })
      .then((response) => { setDeal(response.data.data) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
      .finally(() => { setIsLoading(false) })
  }
  const updatePacking = (values, formikBag) => {
    OutboundDealsApi.updatePacking({ dealId: id, ...values })
      .then((response) => {
        if(response.status === 200){
          const msg = 
          <>
            { 'Packing data berhasil diubah' } &nbsp;
            <Button onClick={fetchDeal} block color="info" className='mb-3'>Klik disini untuk Refresh Data</Button>
          </>
          pageUtils.setAlertMsg(msg, ALERT_TYPES.SUCCESS)
        }
      })
      .catch((error) => {
        formikBag.setErrors(error.response.data.messages)
        pageUtils.setApiErrorMsg(error.response.data)
      })
      .finally(() => {
        formikBag.setSubmitting(false)
      })
  }
  const updateShipment = (values, formikBag) => {
    OutboundDealsApi.updateShipment({ dealId: id, ...values })
      .then((response) => {
        if(response.status === 200){
          const msg =
          <>
            { 'Shipment data berhasil diubah' } &nbsp;
            <Button onClick={fetchDeal} block color="info" className='mb-3'>Klik disini untuk Refresh Data</Button>
          </>
          pageUtils.setAlertMsg(msg, ALERT_TYPES.SUCCESS)
        }
      })
      .catch((error) => {
        formikBag.setErrors(error.response.data.messages)
        pageUtils.setApiErrorMsg(error.response.data)
      })
      .finally(() => {
        formikBag.setSubmitting(false)
      })
  }
  const orderPickup = () => {
    OutboundDealsApi.orderPickup({ dealId: id })
      .then((response) => {
        if(response.status === 200){
          const msg = 'Request pickup berhasil'
          pageUtils.setAlertMsg(msg, ALERT_TYPES.SUCCESS)
          fetchDeal()
        }
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data.messages)
      })
  }

  const fetchHistoryList = () => {
    OutboundDealsApi.listHistory({ dealId: id })
      .then((response) => { setHistoryList(response.data?.data?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
  }
  const fetchHistoryDetail = (id) => {
    OutboundDealsApi.getHistory({ historyId: id })
      .then((response) => { setHistoryDetail(response.data.data) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
  }
  const clearHistoryDetail = () => {
    setHistoryDetail({})
  }

  useEffect(() => {
    fetchDeal()
  }, [ id ])

  return (
    <>
      <TitlePage mainTitle={ 'Outbound Deal' }/>
      <OutboundDealsView
        updatePacking={ updatePacking }
        updateShipment={ updateShipment }
        orderPickup={ orderPickup }
        fetchDeal={ fetchDeal }
        deal={ deal }
        fetchHistoryList={ fetchHistoryList }
        fetchHistoryDetail={ fetchHistoryDetail }
        clearHistoryDetail={ clearHistoryDetail }
        historyList={ historyList }
        historyDetail={ historyDetail }
        isLoading={ isLoading }
      />
    </>
  )
}

OutboundDealsDetailPage.propTypes = propTypes

export default OutboundDealsDetailPage